module.exports = "/* .row{\r\n    margin-top:4px;\r\n    padding:2px;\r\n} */\r\n\r\n.row{\r\n    padding: 1em 0px 0px 0px !important;\r\n    margin-bottom: -10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/website-news/websitenews-form/websitenews-form.component.css
// module id = ./src/app/allocation/website-news/websitenews-form/websitenews-form.component.css
// module chunks = main